import Canvas from '../canvas/Canvas.js';

class Timeline extends Canvas {

  onRender() {
    return null;
  }

  onInit() {
    this.background('#252A33');
  }

  onDraw() {
    this.clear();

    super.onDraw();
  }

}

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/timeline/Timeline.js